
import LazyHydrate from 'vue-lazy-hydration';
import ProductDiscountMarker from '../ProductDiscountMarker/ProductDiscountMarker.vue';
import type { Product } from '~/type/product/Product';
import TSBonusCount from '~/components/ts-components/TSBonusCount/TSBonusCount.vue';
import TSPrice from '~/components/ts-components/TSPrice/TSPrice.vue';
import TSCounter from '~/components/ts-components/TSCounter/TSCounter.vue';
import ActionCart from '~/action/ActionCart.vue';
interface Props {
  product: Product;
  source?: string;
}
const __sfc_main = {};
__sfc_main.props = {
  product: {
    key: "product",
    required: true,
    type: null
  },
  source: {
    key: "source",
    required: false,
    type: String
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const emit = __ctx.emit;
  return {
    emit
  };
};
__sfc_main.components = Object.assign({
  LazyHydrate,
  TSPrice,
  TSBonusCount,
  ProductDiscountMarker,
  ActionCart,
  TSCounter
}, __sfc_main.components);
export default __sfc_main;
